import { render, staticRenderFns } from "./PostContentItemLayout.vue?vue&type=template&id=6cffcab8&scoped=true&"
import script from "./PostContentItemLayout.vue?vue&type=script&lang=js&"
export * from "./PostContentItemLayout.vue?vue&type=script&lang=js&"
import style0 from "./PostContentItemLayout.vue?vue&type=style&index=0&id=6cffcab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffcab8",
  null
  
)

export default component.exports